import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

import { getCoachesAvailabilitiesQuerySchema } from './coach.js';

const coachPoolFiltersSchema = getCoachesAvailabilitiesQuerySchema.pick({
  query: true,
  statuses: true,
  subStatuses: true,
  overallGrades: true,
  classEligibilities: true,
  backgroundCheckStatuses: true,
  backgroundCheckStatusesLogicalOperator: true,
  googleMeetTechCheck: true,
  hasAvailability: true,
  timeRanges: true,
  untakenTeachersOnly: true,
  coachAvailabilityType: true,
  states: true,
});
export type CoachPoolFilters = z.infer<typeof coachPoolFiltersSchema>;

export const createCoachPoolSchema = coachPoolFiltersSchema.extend({
  title: z.string().trim().min(1),
  description: z.string().optional(),
  isActive: z.boolean().optional(),
});
export type CreateCoachPool = z.infer<typeof createCoachPoolSchema>;

export const coachPoolSchema = coachPoolFiltersSchema.required().extend({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  isActive: z.boolean(),
  query: z.string().nullable(),
  backgroundCheckStatusesLogicalOperator: coachPoolFiltersSchema.shape.backgroundCheckStatusesLogicalOperator
    .unwrap()
    .nullable(),
  googleMeetTechCheck: z.boolean().nullable(),
  hasAvailability: z.boolean().nullable(),
  timeRanges: coachPoolFiltersSchema.shape.timeRanges.unwrap().nullable(),
  untakenTeachersOnly: z.boolean().nullable(),
  coachAvailabilityType: coachPoolFiltersSchema.shape.coachAvailabilityType.unwrap().nullable(),
  createdAt: z.instanceof(Temporal.Instant),
  updatedAt: z.instanceof(Temporal.Instant),
});
export type CoachPool = z.infer<typeof coachPoolSchema>;
